export enum ActiveTab {
  STATISTICS,
  LOG,
}
